import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { BookClub } from '../../models/bookclub';
import { ApiService } from '../../services/api.service';
import { AuthService } from '../../services/auth.service';
import { LocaleService } from 'src/app/services/locale.service';
import { RecordSwipperItem, RecordSwipperUtils } from 'src/app/models/record-swiper';
import { UserFacade } from 'src/app/_core/state/user/user.facade';

@Component({
  selector: 'app-slider-book-clubs',
  templateUrl: './slider-book-clubs.component.html',
  styleUrls: ['../slider/slider.component.scss', './slider-book-clubs.component.scss'],
})
export class SliderBookClubsComponent {
  private readonly userFacade = inject(UserFacade);

  @Input()
  items: BookClub[];

  @Input()
  title: string;

  @Output()
  selected: EventEmitter<BookClub> = new EventEmitter();

  swiperItems: RecordSwipperItem[] = [];
  fadeAnimation: string;
  titleI18N: string;
  textDirection: string;
  selectedItemIndex: number;

  constructor(
    private apiService: ApiService,
    private authService: AuthService,
    private localeService: LocaleService
  ) {}

  ngOnInit() {
    this.textDirection = this.localeService.getTextDirection();
    this.titleI18N = 'bookclub.carousel.' + this.title;
    this.buildSwiperItems();
  }

  private buildSwiperItems() {
    this.swiperItems = [];
    this.items.forEach((oleItem) => this.swiperItems.push(RecordSwipperUtils.fromOleItemToSwiperItem(oleItem)));
  }

  onSelected(clickedItemIndex: number, item: RecordSwipperItem) {
    const userId = this.authService.isAuthenticated() ? this.userFacade.user.id : null;

    const params = {
      clubId: item.id,
      patronId: userId,
    };

    if (this.selectedItemIndex === clickedItemIndex) {
      this.onCloseInfo();
      return;
    }

    this.apiService.getLinkToBookclub(params).subscribe((url) => {
      const backUrl = new URL(location.href);
      backUrl.searchParams.set('showReturnButton', 'false');
      const completeUrl = new URL(url);

      if (!url.includes('clubId')) {
        completeUrl.searchParams.set('clubId', params['clubId']);
      }

      completeUrl.searchParams.set('backUrl', backUrl.toString());

      window.location.href = completeUrl.toString();
    });
  }

  onCloseInfo() {
    this.selectedItemIndex = null;
  }
}
